// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wSU1","title":"Header_title__i2oO9","side":"Header_side__641gd"};